var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._l((_vm.scan_list),function(code){return _c('p',[_vm._v(_vm._s(code))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }